export const SET_EDIT_PROGRAM = 'SET_EDIT_PROGRAM';
export const SAVE_EDIT_PROGRAM = 'SAVE_EDIT_PROGRAM';
export const ADD_OFFER = 'ADD_OFFER';
export const ADD_OFFER_IN_REP = 'ADD_OFFER_IN_REP';
export const DELETE_OFFER = 'DELETE_OFFER';
export const CHANGE_COLLAPSE = 'CHANGE_COLLAPSE';
export const CHANGE_COLLAPSE_REP = 'CHANGE_COLLAPSE_REP';
export const SAVE_OFFER = 'SAVE_OFFER';
